import { Grid } from '@mui/material';
import { WsTypography, WsTypoVariants } from 'wisestep-base';

import CountWithTextCard from '../../../../analytics/components/countWithTextCard';
import { usePostgreCvUploadWidgetsData } from '../../../../composableAnalytics/DerivedCharts/cvUpload/hooks/usePostgreCvUploadWidgetsData';
import { IPostgreCvUploadDTO } from '../../jobs/types/postgreJobsDTO';
import { ICvUploadWidgetProp } from '../../jobs/types/postgreJobsWidgetProp';
import { defaultCvUploadWidgetData } from '../utils/cvUploadHelper';

const CvUploadMetricChartPostgre = ({ query, title }: ICvUploadWidgetProp) => {
  const { widgetData } = usePostgreCvUploadWidgetsData<IPostgreCvUploadDTO>(
    query,
    defaultCvUploadWidgetData
  );

  return (
    <Grid container p={2}>
      <Grid item xs={12} mb={2}>
        <WsTypography variant={WsTypoVariants.TITLE} bold={true}>
          {title}
        </WsTypography>
      </Grid>
      <Grid item xs={1} ml={10}>
        <CountWithTextCard
          variant="h4"
          count={widgetData.totalCount ?? 0}
          fullHeight
          text="Total CVs"
          textVariant="caption"
        />
      </Grid>
      <Grid item xs={1} ml={10}>
        <CountWithTextCard
          variant="h4"
          count={widgetData.totalSuccess ?? 0}
          fullHeight
          text="Success"
          textVariant="caption"
        />
      </Grid>
      <Grid item xs={1} ml={10}>
        <CountWithTextCard
          variant="h4"
          count={widgetData.totalProcessing ?? 0}
          fullHeight
          text="In Process"
          textVariant="caption"
        />
      </Grid>
      <Grid item xs={1} ml={10}>
        <CountWithTextCard
          variant="h4"
          count={widgetData.totalFailed ?? 0}
          fullHeight
          text="Failed"
          textVariant="caption"
        />
      </Grid>
    </Grid>
  );
};

export default CvUploadMetricChartPostgre;
